import "./component.scss";

(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const headers = document.querySelectorAll(".faq_accordion__header");
    const carets = document.querySelectorAll(".faq_accordion__caret");

    headers.forEach((header) => {
      header.addEventListener("click", function () {
        headers.forEach((h) => h.classList.remove("open"));
        carets.forEach((h) => h.classList.remove("rotate-180"));

        const currentContent = this.nextElementSibling;
        const isCurrent = currentContent.classList.contains("open");
        const caret = this.querySelector(".faq_accordion__caret");

        const openContent = document.querySelector(
          ".faq_accordion__content.open"
        );

        if (openContent) {
          openContent.classList.remove("open");
        }

        if (!isCurrent) {
          currentContent.classList.add("open");
          this.classList.toggle("open");
          caret.classList.toggle("rotate-180");
        }
      });
    });
  });
})();



// WEBPACK FOOTER //
// ./app/components/faq_accordion/component.js